import React from "react";
import "./MetricsCard.css";
import {
  Assessment,
  Chat,
  Star,
  Description,
  EmojiEvents,
} from "@mui/icons-material";
import ActivityIcon from "../../../Assets/Images/activity- icon.svg";

const MetricsCard = ({ metrics }) => {
  if (!metrics) return null;

  const metricsConfig = [
    {
      key: "profilesReviewed",
      label: "Profiles Reviewed",
      icon: Assessment,
      color: "#4CAF50",
    },
    { key: "spoken", label: "Spoken", icon: Chat, color: "#2196F3" },
    { key: "interested", label: "Interested", icon: Star, color: "#FF9800" },
    { key: "proposed", label: "Proposed", icon: Description, color: "#9C27B0" },
    {
      key: "interviews",
      label: "Interviews",
      icon: Chat,
      color: "#E91E63",
    },
    { key: "offers", label: "Offers", icon: EmojiEvents, color: "#4CAF50" },
  ];

  return (
    <div className="metrics-card">
      <div className="metrics-card-header">
        <span className="metrics-card-header-icon">
          <img
          alt="activityicon"
          src={ActivityIcon}
          />
        </span>
        <span className="metrics-card-header-title">Activity Snapshot</span>
      </div>

      <div className="metrics-grid">
        {metricsConfig.map((item) => {
          const IconComponent = item.icon || Assessment;
          return (
            <div key={item.key} className="metric-item">
              <div className="metric-label">{item.label}</div>
              <div className="metric-value-row">
                <IconComponent
                  className="metric-icon"
                  style={{ fontSize: 15, color: item.color }}
                />
                <span className="metric-value">{metrics[item.key] || 0}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MetricsCard;
